import React, { useEffect, useRef, useState } from 'react';
import {
   Backdrop,
   Box,
   Button,
   Checkbox,
   Dialog,
   DialogActions,
   DialogTitle,
   FormControlLabel,
   Grid,
   IconButton,
   InputAdornment,
   Paper,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import {
   AlertLabel,
   Input,
   TextArea,
   TextFieldCustom,
} from '../../../assets/styled/Element';
import { Controller, useForm } from 'react-hook-form';
import { endOfDay, format } from 'date-fns';
import { enUS, th } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import { DatePicker, useDateInput } from 'react-nice-dates';
import { TitleLabel } from '../../../components/Element/LabelInputForm';
import {
   checkStatusSelect,
   reverseFormatNumber,
} from '../../../configs/helpers/utility';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { MySelect } from '../../Select/Select';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond/dist/filepond.min.css';
import styled from '@emotion/styled';
import { faFileEdit } from '@fortawesome/pro-duotone-svg-icons';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';
import { GSBtoWording } from '../../../configs/helpers/GSBtoWording';

registerPlugin(
   FilePondPluginImagePreview,
   FilePondPluginImageExifOrientation,
   FilePondPluginFileValidateType,
);
const Div = styled('div')`
   position: relative;
   text-align: center;
`;
const CenterButton = styled('div')`
   position: absolute;
   top: 8px;
   right: 16px;
`;
const ImgItems = styled('img')`
   width: 100%;
   border-radius: 5px;
   box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
      0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06),
      0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086),
      0 100px 80px rgba(0, 0, 0, 0.12);
`;
const optionsStatus = [
   { value: 1, label: 'Active', color: '#4ba23a' },
   { value: 2, label: 'Inactive', color: '#9e9e9e' },
];
const optionsType = [
   { value: 1, label: 'Physical' },
   { value: 2, label: 'Code/Serial' },
];
const optionsLimited = [
   { value: 1, label: 'Unlimited' },
   { value: 2, label: 'Limited' },
];

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '45%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));
function Edit(props) {
   const classes = useStyles();
   const [data, setData] = useState(props.data);
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const [disbledRedeemQty, setDisbledRedeemQty] = useState(false);
   const closeRef = useRef();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {
         type: data.type === 1 ? 'Physical' : 'Code/Serial',
         Reference: data.rewardRef,
         nameTh: data.rewardTh,
         nameEn: data.rewardEn,
         detailTh: data.detailTh ?? '',
         detailEn: data.detailEn ?? '',
         startDate: new Date(data.validFrom),
         endDate: new Date(data.validThrough),
         gPointPerPerson: new Intl.NumberFormat().format(data.gPoint),
         sPointPerPerson: new Intl.NumberFormat().format(data.sPoint),
         bPointPerPerson: new Intl.NumberFormat().format(data.bPoint),
         isLockCurrency: data.isLockCurrency,
         status: checkStatusSelect(data.status),
      },
   });
   const [isLoadingPhase, setIsLoadingPhase] = useState(true);
   const [resp, setResp] = useState(null);
   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      Axios.get(`/GSB/dashboard/reward/Get?RewardRef=${data.rewardRef}`)
         .then((response) => {
            setResp(response.data);
            if (response.data.Redeem_LimitMode === 2) {
               setDisbledRedeemQty(true);
            } else {
               setDisbledRedeemQty(false);
            }
         })
         .catch((e) => {
            LogToBackend(e);
            setIsError({
               error: true,
               errorStatus: e.response.status,
               errorMessage: e.response.data.errorAppMessageTh
                  ? e.response.data.errorAppMessageTh
                  : 'เกิดข้อผิดพลาด',
            });
         })
         .finally(() => {
            setIsLoadingPhase(false);
         });
   };
   const [hideEditUpload, setHideEditUpload] = useState(true);
   const files = watch('coverImage');
   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');
   const selectCheckbox = watch('isLockCurrency');
   const [termTh, setTermTh] = useState(data.termsAndCondsTh);
   const [termEn, setTermEn] = useState(data.termsAndCondsEn);
   const [popup, setPopup] = useState(false);
   useEffect(() => {
      register({ name: 'coverImage' });
      register({ name: 'startDate' }, { required: true });
      register({ name: 'endDate' }, { required: true });
      register({ name: 'isLockCurrency' });
   }, [register]);
   const [filestate, setFilestate] = useState('');

   const handleIsLockCurrency = (e) => {
      setValue('isLockCurrency', e.target.checked);
   };
   const pondRef = useRef(null);
   const MAX_FILE_SIZE = 10;
   const setFiles = (e) => {
      const oversized = e.filter(
         (f) => f.file && f.file.size > MAX_FILE_SIZE * 1024 * 1024,
      );
      if (oversized.length > 0) {
         oversized.forEach(
            (f) => pondRef.current && pondRef.current.removeFile(f),
         );
         enqueueSnackbar(`ขนาดไฟล์รูปภาพต้องไม่เกิน ${MAX_FILE_SIZE} MB`, {
            variant: 'error',
            preventDuplicate: true,
         });
         return;
      }
      setValue('coverImage', e);
   };
   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };
   const timeStartInputProps = useDateInput({
      date: getValues('startDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleStartDateChange,
   });
   const timeEndInputProps = useDateInput({
      date: getValues('endDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleEndDateChange('manual'),
   });
   const handleClosePopup = () => {
      setPopup(false);
   };
   const onSubmit = (e) => {
      sessionStorage.setItem('value', JSON.stringify(e));
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         if (e.isLockCurrency) {
            setFilestate(e.coverImage);
            setPopup(true);
         } else {
            postData(values, e.coverImage);
         }
      }
   };
   const popupPostData = () => {
      setPopup(false);
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         postData(values, filestate);
      }
   };

   const postData = (values, objFile) => {
      setIsLoading(true);
      const formData = new FormData();
      if (objFile) {
         formData.append('coverImage', objFile[0].file, objFile[0].file.name);
      }
      formData.append('isLockCurrency', values.isLockCurrency ? true : false);
      formData.append('Reference', values.Reference);
      formData.append('status', values.status.value);
      // formData.append('type', values.type.value);
      formData.append('nameTh', values.nameTh.trim());
      formData.append('nameEn', values.nameEn.trim());
      formData.append('detailTh', values.detailTh);
      formData.append('detailEn', values.detailEn);
      formData.append(
         'redeemLimitMode',
         values.redeemLimitMode
            ? values.redeemLimitMode.value
            : resp.Redeem_LimitMode,
      );
      formData.append('reserveTimeout', 300);
      formData.append(
         'redeemLimitQty',
         values.redeemCodeQty
            ? +reverseFormatNumber(values.redeemCodeQty, 'en')
            : resp.Redeem_LimitQty
            ? resp.Redeem_LimitMode === 1
               ? 0
               : resp.Redeem_LimitQty
            : values.redeemLimitMode &&
              values.redeemLimitMode.value === 'Reward'
            ? 0
            : resp.Redeem_LimitQty,
      );
      formData.append('termsAndCondsTh', termTh ? termTh : '');
      formData.append('termsAndCondsEn', termEn ? termEn : '');
      formData.append(
         'startDate',
         format(new Date(values.startDate), 'dd/MM/yyyy HH:mm:ss'),
      );
      formData.append(
         'endDate',
         format(new Date(values.endDate), 'dd/MM/yyyy HH:mm:ss'),
      );
      formData.append(
         'gPoint',
         +reverseFormatNumber(values.gPointPerPerson, 'en'),
      );
      formData.append(
         'sPoint',
         +reverseFormatNumber(values.sPointPerPerson, 'en'),
      );
      formData.append(
         'bPoint',
         +reverseFormatNumber(values.bPointPerPerson, 'en'),
      );
      Axios.post('/GSB/dashboard/reward/Edit', formData)
         .then((resp) => {
            // console.log(resp);
            enqueueSnackbar('แก้ไขรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   if (isLoadingPhase) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <Dialog
            open={popup}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
         >
            <DialogTitle id='alert-dialog-title'>
               ของรางวัลนี้กำหนดประเภทคะแนนที่ใช้แลก
            </DialogTitle>
            <DialogActions>
               <Button onClick={handleClosePopup}>ยกเลิก</Button>
               <Button onClick={popupPostData} color='primary' autoFocus>
                  ยืนยัน
               </Button>
            </DialogActions>
         </Dialog>
         <div className={classes.header}>
            <Typography variant={'h4'}>แก้ไขของรางวัล</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={2}>
                     <Grid item xs={6}>
                        <TitleLabel>
                           สถานะ
                           {errors.status && (
                              <AlertLabel>กรุณาเลือกสถานะ</AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={optionsStatus}
                                 placeholder={'เลือกสถานะ'}
                                 closeMenuOnSelect
                                 colourStyles
                              />
                           }
                           rules={{ required: true }}
                           onChange={([selected]) => {
                              return selected;
                           }}
                           name='status'
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ประเภท
                           {errors.type && (
                              <AlertLabel>กรุณาเลือกประเภท</AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'type'}
                           placeholder={'ประเภท'}
                           ref={register()}
                           disabled
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>อ้างอิง</TitleLabel>
                        <Input
                           name={'Reference'}
                           placeholder={'อ้างอิง'}
                           ref={register()}
                           disabled
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ชื่อ (ภาษาไทย)
                           {errors.nameTh && (
                              <AlertLabel>กรุณาระบุชื่อ (ภาษาไทย)</AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'nameTh'}
                           placeholder={'ชื่อ (ภาษาไทย)'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ชื่อ (ภาษาอังกฤษ)
                           {errors.nameEn && (
                              <AlertLabel>
                                 กรุณาระบุชื่อ (ภาษาอังกฤษ)
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'nameEn'}
                           placeholder={'ชื่อ (ภาษาอังกฤษ)'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>รายละเอียด (ภาษาไทย)</TitleLabel>
                        <TextArea
                           name={'detailTh'}
                           placeholder={'รายละเอียด (ภาษาไทย)'}
                           ref={register()}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>รายละเอียด (ภาษาอังกฤษ)</TitleLabel>
                        <TextArea
                           name={'detailEn'}
                           placeholder={'รายละเอียด (ภาษาอังกฤษ)'}
                           ref={register()}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>กติกา และเงื่อนไข (ภาษาไทย)</TitleLabel>
                        <Box width={'100%'}>
                           <ReactQuill
                              value={termTh}
                              onChange={(e) => setTermTh(e)}
                           />
                        </Box>
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>กติกา และเงื่อนไข (ภาษาอังกฤษ)</TitleLabel>
                        <Box width={'100%'}>
                           <ReactQuill
                              value={termEn}
                              onChange={(e) => setTermEn(e)}
                           />
                        </Box>
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           จำกัดจำนวนการแลกต่อคน
                           {errors.redeemLimitMode && (
                              <AlertLabel>กรุณาเลือก</AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={optionsLimited}
                                 placeholder={'เลือก'}
                                 closeMenuOnSelect
                                 defaultInputValue={
                                    resp.Redeem_LimitMode === 1
                                       ? 'Unlimited'
                                       : 'Limited'
                                 }
                              />
                           }
                           // rules={{ required: true }}
                           onChange={([selected]) => {
                              if (selected) {
                                 if (selected.value === 2) {
                                    setDisbledRedeemQty(true);
                                 } else setDisbledRedeemQty(false);
                                 return selected;
                              } else setDisbledRedeemQty(false);
                              return selected;
                           }}
                           name='redeemLimitMode'
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        {disbledRedeemQty ? (
                           <React.Fragment>
                              <TitleLabel>จำนวนการแลกต่อครั้ง</TitleLabel>
                              <Controller
                                 as={
                                    <Input
                                       name={'redeemCodeQty'}
                                       placeholder={'จำนวนการแลกต่อครั้ง'}
                                       defaultValue={
                                          resp.Redeem_LimitQty &&
                                          new Intl.NumberFormat().format(
                                             resp.Redeem_LimitQty,
                                          )
                                       }
                                    />
                                 }
                                 onChange={([e]) => {
                                    return new Intl.NumberFormat().format(
                                       e.target.value.replace(/[^0-9]/g, ''),
                                    );
                                 }}
                                 name={'redeemCodeQty'}
                                 control={control}
                              />
                           </React.Fragment>
                        ) : (
                           <div>&nbsp;</div>
                        )}
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ใช้ได้ตั้งแต่
                           {errors.startDate && (
                              <AlertLabel>กรุณาเลือกวันที่</AlertLabel>
                           )}
                        </TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectStartDate}
                              onDateChange={handleStartDateChange}
                              // locale={th}
                              // format="dd MMM yyyy"
                              locale={enUS}
                           >
                              {({ inputProps, focused }) => (
                                 <Box width={'100%'}>
                                    <Input
                                       className={
                                          'input' + (focused ? ' -focused' : '')
                                       }
                                       {...inputProps}
                                       value={`${
                                          inputProps.value &&
                                          dayjs(
                                             new Date(inputProps.value),
                                          ).format('DD/MM/BBBB')
                                       }`}
                                       width={'52%'}
                                       margin={'0px 3% 0px 0px'}
                                       placeholder={'เลือกวันที่'}
                                       readOnly
                                    />
                                    <Input
                                       className='input'
                                       {...timeStartInputProps}
                                       width={'45%'}
                                       type={'time'}
                                    />
                                 </Box>
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ใช้ได้จนถึง
                           {errors.endDate && (
                              <AlertLabel>กรุณาเลือกวันที่</AlertLabel>
                           )}
                        </TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectEndDate}
                              onDateChange={handleEndDateChange('auto')}
                              // locale={th}
                              // format="dd MMM yyyy"
                              locale={enUS}
                              minimumDate={
                                 getValues('startDate')
                                    ? getValues('startDate')
                                    : new Date()
                              }
                           >
                              {({ inputProps, focused }) => (
                                 <Box width={'100%'}>
                                    <Input
                                       className={
                                          'input' + (focused ? ' -focused' : '')
                                       }
                                       {...inputProps}
                                       value={`${
                                          inputProps.value &&
                                          dayjs(
                                             new Date(inputProps.value),
                                          ).format('DD/MM/BBBB')
                                       }`}
                                       width={'52%'}
                                       margin={'0px 3% 0px 0px'}
                                       placeholder={'เลือกวันที่'}
                                       readOnly
                                    />
                                    <Input
                                       className='input'
                                       {...timeEndInputProps}
                                       width={'45%'}
                                       type={'time'}
                                    />
                                 </Box>
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>
                           มูลค่าการใช้คะแนน(GSB Way of Work)
                           {(errors.gPointPerPerson ||
                              errors.sPointPerPerson ||
                              errors.bPointPerPerson) && (
                              <AlertLabel>
                                 กรุณาระบุคะแนนให้ครบทุกช่อง
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Box display='flex' gridGap={'8px'}>
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    // width={'30%'}
                                    placeholder={'B'}
                                    // margin={'0px 3.33% 0px 0px'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             for SOCIETY
                                          </InputAdornment>
                                       ),
                                    }}
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              rules={{ required: true }}
                              name={'bPointPerPerson'}
                              control={control}
                           />
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    // width={'30%'}
                                    placeholder={'G'}
                                    // margin={'0px 3.33% 0px 0px'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             with GOVERNANCE
                                          </InputAdornment>
                                       ),
                                    }}
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              rules={{ required: true }}
                              name={'gPointPerPerson'}
                              control={control}
                           />
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    // width={'30%'}
                                    placeholder={'S'}
                                    // margin={'0px 3.33% 0px 0px'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             through DIGITALIZATION
                                          </InputAdornment>
                                       ),
                                    }}
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              rules={{ required: true }}
                              name={'sPointPerPerson'}
                              control={control}
                           />
                        </Box>
                        <FormControlLabel
                           control={
                              <Checkbox
                                 name={'isLockCurrency'}
                                 color={'primary'}
                                 size={'small'}
                                 checked={selectCheckbox}
                                 onChange={handleIsLockCurrency}
                              />
                           }
                           style={{ color: 'red' }}
                           label={'กำหนดประเภทคะแนนที่ใช้แลก'}
                        />
                     </Grid>

                     <Grid item xs={6}>
                        {hideEditUpload ? (
                           <React.Fragment>
                              <TitleLabel>รูปภาพ</TitleLabel>

                              <Div>
                                 <ImgItems
                                    src={data?.image?.rawUrl ?? ''}
                                    alt={data?.rewardTh ?? ''}
                                 />
                                 <CenterButton>
                                    <Button
                                       variant={'contained'}
                                       onClick={() => setHideEditUpload(false)}
                                       size={'small'}
                                       color='primary'
                                       startIcon={
                                          <FontAwesomeIcon
                                             icon={faFileEdit}
                                             size={'xs'}
                                          />
                                       }
                                    >
                                       แก้ไข
                                    </Button>
                                 </CenterButton>
                              </Div>

                              <AlertLabel>
                                 ขนาดไฟล์ไม่เกิน {MAX_FILE_SIZE} mb
                                 ขนาดรูปภาพไม่เกิน 140x140 px
                              </AlertLabel>
                           </React.Fragment>
                        ) : (
                           <React.Fragment>
                              <TitleLabel>
                                 รูปภาพ
                                 {errors.coverImage && (
                                    <AlertLabel>กรุณาเลือกรูปภาพ</AlertLabel>
                                 )}
                              </TitleLabel>

                              <FilePond
                                 ref={pondRef}
                                 files={files}
                                 onupdatefiles={setFiles}
                                 name='coverImage'
                                 labelIdle='วางภาพ หรือ <span class="filepond--label-action">คลิกที่นี่</span>'
                              />

                              <AlertLabel>
                                 ขนาดไฟล์ไม่เกิน {MAX_FILE_SIZE} mb
                                 ขนาดรูปภาพไม่เกิน 140x140 px
                              </AlertLabel>
                           </React.Fragment>
                        )}
                     </Grid>
                  </Grid>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        ยืนยัน
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </form>
      </Paper>
   );
}

export default Edit;
